import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'million',
    standalone: false
})
export class MillionPipe implements PipeTransform {

  transform(value: number): string {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + 'M';
    } else {
      return value.toString();
    }
  }

}